export class TrialReport {
  public patientsEnrolled = 0;
  public patientsRetained = 0;
  public visitsScheduled = 0;
  public visitsCompleted = 0;
  public expenseRequests = 0;
  public expenseRequestsProcessed = 0;
  public carTrips = 0;
  public carPercent = 0;
  public trainTrips = 0;
  public trainPercent = 0;
  public planeTrips = 0;
  public planePercent = 0;
  public platforms: TrialReportPlatform[] = [];

  constructor(init?: Partial<TrialReport>) {
    Object.assign(this, init);

    if (init && init.platforms && init.platforms.length > 0) {
      this.platforms = init.platforms.map(p => new TrialReportPlatform(p));
    }

    // Calculate the percentages of each platform based on the total count of all platforms
    if (this.platforms && this.platforms.length > 0) {
      const total = this.platforms.reduce((sum, p) => sum + p.count, 0);
      
      // Calculate percentages with proper rounding to ensure total equals 100%
      const percentages = this.platforms.map(p => (p.count / total) * 100);
      const roundedPercentages = percentages.map(p => Math.floor(p));
      const remainders = percentages.map((p, i) => ({ index: i, remainder: p - roundedPercentages[i] }));
      
      // Distribute the remaining percentage points to platforms with highest remainders
      const totalRounded = roundedPercentages.reduce((sum, p) => sum + p, 0);
      const difference = 100 - totalRounded;
      
      remainders.sort((a, b) => b.remainder - a.remainder);
      for (let i = 0; i < difference; i++) {
        roundedPercentages[remainders[i].index]++;
      }
      
      this.platforms.forEach((p, i) => {
        p.percent = roundedPercentages[i];
      });
    }
  }
}

export class TrialReportPlatform {
  public platform: string;
  public count: number;
  public percent: number;

  constructor(init?: Partial<TrialReportPlatform>) {
    Object.assign(this, init);
  }
}
